import { Link } from "react-router-dom";
import useLang from "hooks/useLang";

const GalleryCard = ({ title, description, to, icon }) => {
  const { lang } = useLang();

  return (
    <div class="service-block col-lg-3 col-md-6 col-sm-12">
      <div class="inner-box">
        <div class="icon-box">
          <span class={icon}></span>
        </div>
        <h5>
          <Link to={to}>{title}</Link>
        </h5>
        <div class="text">
          {description}
        </div>
        <Link class="read-more" to={to}>
          {lang.services.our_services.service_card_cta}<span class="ti-angle-right"></span>
        </Link>
      </div>
    </div>
  );
};

export default GalleryCard;
